import { StrictMode, type ReactNode } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { AppProviders, type AppDeps } from './deps';
import type { AppRouter } from './router';

/**
 * Draws the app into its page. The route is settled first, so the first draw
 * is the screen itself: a pre-drawn login.html is replaced by the same form,
 * never by a blank page (issue #8). A route that fails to settle still draws:
 * the router shows its own error.
 */
export async function startApp(container: HTMLElement, deps: AppDeps, router: AppRouter, extra?: ReactNode): Promise<Root> {
  await router.load().catch(() => undefined);
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <AppProviders deps={deps}>
        {extra}
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
  return root;
}
